import React, { useEffect, useState } from 'react';
import moment from 'moment-timezone';
import { MenuItem, Select, InputLabel, FormControl } from '@mui/material';

function TimezoneSelector({ onTimezoneChange }) {
    const [timezones, setTimezones] = useState([]);
    const [selectedTimezone, setSelectedTimezone] = useState('');

    useEffect(() => {
        const tzNames = moment.tz.names();
        setTimezones(tzNames);
        setSelectedTimezone(tzNames[0]); // Optionally set a default value
    }, []);

    const handleChange = (event) => {
        setSelectedTimezone(event.target.value);
        if (onTimezoneChange) {
            onTimezoneChange(event.target.value);
        }
    };

    return (
        <>
        <FormControl fullWidth margin="normal">
            <InputLabel id="timezone-select-label">Timezone</InputLabel>
            <Select
                labelId="timezone-select-label"
                id="timezone-select"
                label="Timezone"
                onChange={handleChange}                
                value={selectedTimezone}>
                    {timezones.map(timezone => (
                    <MenuItem value={timezone}>{timezone}</MenuItem>
                ))}
            </Select>
        </FormControl>
      </>
    );
}

export default TimezoneSelector;
